module.exports = __webpack_public_path__ + "static/inna-valouskova-o-mne-b9a1e53619977aeecc8e9de80af9251f.jpg";